import { getBillingData } from "@Modules/eventPage/utils/getBillingData";
import { useEventDataOfSelectedEvent } from "@Utils";
import { postAnalytics } from "repoV2/features/Common/Analytics/Analytics.utils";
import { ANALYTICS_EVENTS } from "repoV2/features/Common/Analytics/Analytics.constants";
import { useInstalmentsDetailsContext } from "../PaymentPlan/utils/InstalmentsDetailsContext";
import { ICTAButtons } from "./CTAButton";
import { useAddToCartCtaButton } from "./useAddToCartCtaButton";

const useCTAButtons = ({
    mainCtaProps: {
        hideComponent: hideMainCta,
        onClick: onMainCtaClick,
        ctaText: mainCtaText,
    },

    addToCartCtaProps,
    hostName,
}: ICTAButtons.IProps) => {
    const {
        hideComponent: hideAddToCartCta,
        onClick: onAddToCartClick,
        ctaText: addToCartText,
    } = useAddToCartCtaButton(addToCartCtaProps);
    const { eventData, event } = useEventDataOfSelectedEvent();
    const {
        title: offeringTitle,
        currency_name: currencyName,
        uuid: listingUuid,
    } = eventData ?? {};
    const {
        paymentInfo: { quantity },
    } = event ?? {};
    const { selectedPaymentType, instalments } = useInstalmentsDetailsContext();
    const [initialPayment] = instalments || [];

    const handleAddToCart = () => {
        if (onAddToCartClick) {
            onAddToCartClick();
        }
    };

    const handleMainBtnClick = () => {
        if (onMainCtaClick) {
            const { billingData } = getBillingData({
                event,
                eventData,
                initialInstalment: initialPayment,
                selectedPaymentType,
            });

            postAnalytics(ANALYTICS_EVENTS.INITIATE_CHECKOUT, {
                sub_domain: hostName,
                event_source_url: window.location.href,
                num_items: quantity,
                value: billingData.totalPrice,
                currency: currencyName,
                items: [
                    {
                        item_id: listingUuid,
                        item_name: offeringTitle,
                    },
                ],
            });

            onMainCtaClick();
        }
    };

    return {
        showAddtoCartCta: !hideAddToCartCta,
        handleAddToCart,
        addToCartText,

        showMainCta: !hideMainCta,
        handleMainBtnClick,
        mainCtaText,
    };
};

export default useCTAButtons;
